<script lang="ts">
  import { theme, colors } from "$lib/utils/theme";
</script>

<!-- Footer - Simple One Line -->
<footer class={theme.footer()}>
  <div class="container px-4 md:px-6 py-4 max-w-7xl mx-auto">
    <div
      class="flex flex-col sm:flex-row justify-between items-center gap-4 text-sm {theme.text.muted()}"
    >
      <p class="whitespace-nowrap">© 2024-2026 Pre6 Inc. All rights reserved.</p>
      <nav
        class="flex items-center justify-center gap-4"
        aria-label="Footer navigation"
      >
        <a
          href="/contact"
          class="{colors.components.footer
            .textHover} transition-colors whitespace-nowrap">Contact</a
        >
        <a
          href="/terms"
          class="{colors.components.footer
            .textHover} transition-colors whitespace-nowrap"
          >Terms & Conditions</a
        >
        <a
          href="/privacy"
          class="{colors.components.footer
            .textHover} transition-colors whitespace-nowrap">Privacy</a
        >
        <a
          href="/security"
          class="{colors.components.footer
            .textHover} transition-colors whitespace-nowrap">Security</a
        >
      </nav>
      <span class="whitespace-nowrap">Made with ❤️ by Pre6</span>
    </div>
  </div>
</footer>
